import axios from "axios";
import settings from "utils/settings";

const { apiUrl } = settings;

export const getResumeFile = (fileId) =>
    axios.get(`${apiUrl}ats/files/${fileId}`, {
        responseType: "blob"
    });

export const downloadResumeFile = (fileId, filename = "resume.pdf") =>
    axios.get(`${apiUrl}ats/files/${fileId}`, {
        responseType: "blob"
    });
